import axios from "axios";
import { BASE_URL } from "./config";

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

export const adminRequest = axios.create({
  baseURL: BASE_URL,
});

adminRequest.interceptors.request.use(
  (config) => {
    const authToken = JSON.parse(sessionStorage.getItem("authToken"));

    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
